<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher<{ verified: void }>();

  // 產生簡單加法題
  function genQuestion() {
    const a = Math.floor(Math.random() * 9) + 1;
    const b = Math.floor(Math.random() * 9) + 1;
    return { a, b, answer: a + b };
  }

  let q = $state(genQuestion());
  let userAnswer = $state('');
  let errorMsg = $state('');
  let attempts = $state(0);

  function handleSubmit() {
    const parsed = parseInt(userAnswer, 10);
    if (parsed === q.answer) {
      dispatch('verified');
    } else {
      attempts++;
      errorMsg = '答案不正確，請再試一次';
      userAnswer = '';
      if (attempts >= 3) {
        // 換題目
        q = genQuestion();
        attempts = 0;
        errorMsg = '已更換題目，請重新作答';
      }
    }
  }

  function handleKeydown(e: KeyboardEvent) {
    if (e.key === 'Enter') handleSubmit();
  }
</script>

<div class="w-full max-w-md mx-auto text-center">
  <div class="mb-8">
    <p class="text-gray-600 text-xl sm:text-2xl">回答以下問題以繼續</p>
  </div>

  <div class="bg-blue-50 border-2 border-blue-300 rounded-2xl p-8 mb-6">
    <p class="text-4xl sm:text-5xl font-black text-blue-800 mb-6">
      {q.a} + {q.b} = ?
    </p>
    <input
      type="tel"
      inputmode="numeric"
      pattern="[0-9]*"
      bind:value={userAnswer}
      onkeydown={handleKeydown}
      placeholder="輸入答案"
      class="w-full px-6 py-5 text-4xl sm:text-5xl font-black text-blue-800 leading-none text-center border-2 border-gray-300 rounded-xl focus:outline-none focus:border-blue-500 bg-white"
    />
  </div>

  {#if errorMsg}
    <p class="text-red-600 text-xl font-bold mb-4">{errorMsg}</p>
  {/if}

  <button
    onclick={handleSubmit}
    disabled={!userAnswer.trim()}
    class="w-full bg-linear-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:from-gray-400 disabled:to-gray-400 text-white p-6 rounded-2xl text-2xl sm:text-3xl font-bold shadow-lg active:scale-95 transition-all"
  >
    確認
  </button>
</div>
